<template>
  <div class="pageContent">
    <div class="content">
      <div class="options">
        <el-form size="small">
          <el-form-item label="手机号" class="option_item" label-width="60px">
            <el-input clearable style="width:160px" v-model="mobile"></el-input>
          </el-form-item>
          <el-form-item class="option_item" label="变动类型" label-width="70px">
            <el-select style="width:100px" v-model="type">
              <el-option label="全部" value="0"></el-option>
              <el-option label="增加" value="1"></el-option>
              <el-option label="减少" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="option_item" label="联盟商家" label-width="70px">
            <el-select style="width:100px" v-model="alliance_app_id">
              <el-option
                :label="item.alliance_room"
                :value="item.alliance_app_id"
                v-for="(item, index) in merchantS"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="option_item" label="时间" label-width="45px">
            <el-date-picker
              v-model="timeValue"
              type="datetimerange"
              range-separator="至"
              style="width: 360px"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            class="option_item"
            label="操作员手机"
            label-width="90px"
          >
            <el-input
              clearable
              style="width:160px"
              v-model="empMobile"
            ></el-input>
          </el-form-item>
          <el-form-item class="option_item" label="变动原因" label-width="70px">
            <el-select style="width:120px" v-model="style">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="签到送积分" value="0"></el-option>
              <el-option label="线下买单" value="1"></el-option>
              <el-option label="充值" value="2"></el-option>
              <el-option label="后台变动" value="3"></el-option>
              <el-option label="回退" value="4"></el-option>
              <el-option label="其他" value="5"></el-option>
              <el-option label="积分兑换" value="6"></el-option>
              <el-option label="邀请新人" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="option_item">
            <el-button type="primary" icon="el-icon-search" @click="getData(1)"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="table_box">
        <el-table :data="tableData" border>
          <el-table-column
            label="用户名"
            prop="user.real_name"
          ></el-table-column>
          <el-table-column label="手机号" prop="user.mobile"></el-table-column>
          <el-table-column
            label="变动金额"
            prop="show_amount"
          ></el-table-column>
          <el-table-column label="变动原因" prop="show_style"></el-table-column>
          <el-table-column
            label="变动时间"
            prop="create_time"
          ></el-table-column>
          <el-table-column label="说明" prop="text"></el-table-column>
          <el-table-column
            label="操作员手机号"
            prop="operate.mobile"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
        <span style="font-size:14px"
          >共计：
          <span style="margin-right:15px">增加：{{ count.add }}</span>
          <span>减少：{{ count.reduce }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getPointLog } from "@/api/vip";
import { getIntegralList } from "@/api/merchant";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      tableData: [], // 表格数据
      page: 1, // 页码
      total: 0, // 总数
      dateValue: [],
      timeValue: [],
      mobile: "",
      count: {},
      type: "0",
      empMobile: "",
      style: "-1",
      styleList: [
        { id: 0, name: "签到送积分" },
        { id: 1, name: "线下买单" },
        { id: 2, name: "充值" },
        { id: 3, name: "后台变动" },
        { id: 4, name: "回退" },
        { id: 5, name: "其他" },
        { id: 6, name: "积分兑换" },
        { id: 7, name: "邀请新人" },
        { id: 8, name: "员工变动" },
      ],
      alliance_app_id: "",
      merchantS: [],
    };
  },
  mounted() {
    this.getData();
    this.getMerchant();
  },
  methods: {
    getData(i) {
      this.page = i || this.page;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
      };
      console.log(this.timeValue);
      if (this.timeValue) {
        data.start_time = this.timeValue[0];
        data.end_time = this.timeValue[1];
      }
      if (this.mobile != "") {
        data.mobile = this.mobile;
      }
      if (this.alliance_app_id != "") {
        data.alliance_app_id = this.alliance_app_id;
      }
      if (this.type != "0") {
        data.type = this.type;
      }
      if (this.style != "-1") {
        data.style = this.style;
      }
      if (this.empMobile != "") {
        data.operate = this.empMobile;
      }
      console.log(data);
      // return false;
      getPointLog(data).then((res) => {
        if (res.code == 200) {
          this.total = res.total;
          this.count = res.count;
          console.log(this.count);
          this.tableData = res.data;
          this.tableData.forEach((item) => {
            item.show_style = this.styleList.find(
              (x) => x.id == item.style
            ).name;
            item.show_amount =
              item.type == 1
                ? "+" + item.num
                : item.type == 2
                ? "-" + item.num
                : item.num;
          });
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message(res.msg);
        }
      });
    },
    getMerchant() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        status: 1,
      };
      getIntegralList(data).then((res) => {
        if (res.code == 200) {
          this.merchantS = res.data.data;
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.pageContent {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    padding: 15px;
    // display: flex;
    // flex-direction: column;
    .options {
      // .options_input{
      //   width: 230px;
      // }
      .input_box_small {
        width: 240px;
      }
      .date_picker_box {
        width: 140px;
      }
      .time_picker_box {
        width: 125px;
        margin-right: 8px;
      }
      .inline_title {
        margin-left: 24px;
        margin-right: 12px;
      }
      .emp_search {
        margin-left: 15px;
      }
      .option_item {
        display: inline-block;
        margin-right: 15px;
      }
    }
    .table_box {
      // flex: 1;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .page {
      margin-top: 15px;
    }
  }
}
</style>
